import { Component, ViewChild, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AutenticacionService } from '../services/autenticacion.service';
import { LoginResponseDto } from '../../../dto/auth/login-response.dto';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { UtilService } from '../../../services/util.service';
import { Constants } from '../../../constants/constants';
import { ModalTipoUsuarioComponent } from '../modal-tipo-usuario/modal-tipo-usuario.component';
import { UsuarioService } from '../../../services/usuario.service';
import { FuncionalidadService } from '../../../services/funcionalidad.service';
import { FormFieldOption } from '../../../dto/util/form-field';
import { SocketService } from '../../../services/socket.service';
import { ProcessService } from '../../../services/process.service';
import { NotificationService } from '../../../services/notification.service';
import { environment } from '../../../../environments/environment';
import { EntidadService } from '../../../services/entidad.service';
import { EntidadDto } from '../../../dto/entidad/entidad.dto';
import { UsuariosGestoresService } from '../../../services/empresas/usuarios-gestores.service';
import { EmpresaGestorDTO, ObtenerEmpresasGestorDTO } from '../../empresas/models/gestorDTO';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  isSecure = environment.esHttps;

  @ViewChild(ModalTipoUsuarioComponent)
  ModalTipoUsuarioComponent!: ModalTipoUsuarioComponent;

  openModalTipoUsuario = false;
  tiposUsuario: FormFieldOption[] = [];
  tipoUsuarioSeleccionado = 0;
  loginResponse?: LoginResponseDto;
  usuarioId?: number = 0;
  URL_LOGIN = `${environment.AUTH_FRONT}/auth/sign-in?entidadId=${environment.ID_ENTITY}`;

  entidadJustifacil: EntidadDto = {
    id: 0,
    entidad: '',
  };

  constructor(
    private fb: FormBuilder,
    private authService: AutenticacionService,
    private alertaModalService: AlertaModalService,
    private notificationService: NotificationService,
    private utilService: UtilService,
    private router: Router,
    private route: ActivatedRoute,
    private usuarioService: UsuarioService,
    private funcionalidadService: FuncionalidadService,
    private socketService: SocketService,
    private processService: ProcessService,
    private entidadService: EntidadService,
    private usuariosGestoresService: UsuariosGestoresService,
  ) {
    this.authService.logout();
    this.entidadService.obtenerEntidadJustifacil().subscribe(response => {
      this.entidadJustifacil = response;
    });

    const state = history.state;
    if (state?.idUsuarioDigital && state?.loginResponse) {
      const idUsuarioDigital = state.idUsuarioDigital;
      this.loginResponse = state.loginResponse;
      this.consultarTiposUsuario(
        Number(idUsuarioDigital)
      );
    } else if (state?.messageErrorDigital) {
      setTimeout(() => {
        this.alertaModalService.error(state.messageErrorDigital);
      }, 1000);
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      const idToken = params['id_token'];

      if (token) {
        this.authService.loginDigital(token, idToken).subscribe({
          next: (data: LoginResponseDto) => {
            if (data.usuario?.idUsuario) {
              this.loginResponse = data;
              this.consultarTiposUsuario(data.usuario.idUsuario);
              // this.router.navigate(['/login'], {
              //   state: {
              //     idUsuarioDigital: data.usuario?.idUsuario,
              //     loginResponse: data,
              //   },
              // });

            } else if (data.usuario?.primerNombre) {
              // Usuario NO existe en BD - Redirige a registro con todos los datos
              this.router.navigate(['/registro'], {
                state: {
                  primerNombreDigital: data.usuario?.primerNombre,
                  segundoNombreDigital: data.usuario?.segundoNombre,
                  primerApellidoDigital: data.usuario?.primerApellido,
                  segundoApellidoDigital: data.usuario?.segundoApellido,
                  correoElectronicoDigital: data.usuario?.correoElectronico,
                  telefonoPrincipalDigital: data.usuario?.telefonoPrincipal,
                  tipoDocumentoDigital: data.usuario?.tipoDocumento,
                  identificacionDigital: data.usuario?.identificacion,
                  usernameDigital: data.usuario?.username,
                  correoDigital: data.usuario?.correoElectronico,
                  direccionDigital: data.usuario?.direccionBasica,
                  usuarioId: data.usuario?.usuarioId
                },
              });
            }
          },
          error: err => {
            console.error('Error en login digital:', err);

            // Extraer mensaje de error apropiado
            let mensajeError = 'Error al iniciar sesión con autenticación digital.';

            if (err.error?.message) {
              mensajeError = err.error.message;
            } else if (err.error?.error) {
              mensajeError = err.error.error;
            }

            this.router.navigate(['/login'], {
              state: { messageErrorDigital: mensajeError },
            });
          },
        });
      }
    });
  }


  loginCorrecto(response: LoginResponseDto) {
    sessionStorage.setItem(
      Constants.USER_INFORMATION_STORAGE,
      JSON.stringify(response.usuario)
    );
    sessionStorage.setItem(Constants.IS_SUCCESS_LOGIN, '1');
    if (!this.isSecure) {
      sessionStorage.setItem(Constants.ACCESS_TOKEN, response.access_token);
      sessionStorage.setItem(Constants.REFRESH_TOKEN, response.refresh_token);
    }

    let token = response.access_token;

    this.utilService.setCookie(Constants.MDJ_ACCESS_TOKEN, response.mdj_auth);
    this.utilService.showNavUser();
    this.authService.executeRefreshToken(token);

    sessionStorage.setItem(
      Constants.USER_DOCUMENT_TYPE,
      response.usuario?.tipoDocumento ?? ''
    );
    sessionStorage.setItem(
      Constants.USER_IDENTIFICATION,
      response.usuario?.identificacion ?? ''
    );
    if (
      response.usuario?.tipoDocumento &&
      response.usuario?.idTipoDocumento &&
      response.usuario?.identificacion &&
      response.usuario?.idUsuario
    ) {
      this.startUserProcess(
        response.usuario.identificacion,
        response.usuario.tipoDocumento,
        response.usuario.idTipoDocumento,
        response.usuario.idUsuario,
        response.usuario.tipoUsuario?.Id ?? 0
      );
    }
  }

  abrirModalTipoUsuario() {
    this.openModalTipoUsuario = true;
    setTimeout(() => {
      this.ModalTipoUsuarioComponent.abrirCerrarModal();
    }, 500);
  }

  consultarTiposUsuario(usuarioId?: number) {
    return this.usuarioService.consultarTiposUsuario(usuarioId!).subscribe({
      next: resp => {
        if (resp.tiposUsuario.length == 1) {
          const rol = resp.tiposUsuario[0];
          this.tipoUsuarioSeleccionado = rol.Id;

          sessionStorage.setItem(
            Constants.USER_TYPE,
            JSON.stringify({
              Id: rol.Id,
              Nombre: rol.Tipo_Usuario,
              Id_Entidad: rol.Id_Entidad,
              Rol_Externo: rol.Rol_Externo
            })
          );

          if (this.loginResponse?.usuario) {
            this.loginResponse.usuario.tipoUsuario = {
              Id: rol.Id,
              Tipo_Usuario: rol.Tipo_Usuario,
              Id_Entidad: rol.Id_Entidad,
              Rol_Externo: rol.Rol_Externo,
              Estado: true
            };
          }

          this.utilService.setRole(rol.Tipo_Usuario || null);
          this.loginCorrecto(this.loginResponse!);
          this.consultarFuncionalidades();
        } else {
          this.tiposUsuario = resp.tiposUsuario.map(tipo => ({
            Id: tipo.Id,
            Nombre: tipo.Tipo_Usuario,
            selected: false,
            Id_Entidad: tipo.Id_Entidad,
            Rol_Externo: tipo.Rol_Externo,
          } as any));

          console.log('tiposUsuario mapeados:', this.tiposUsuario);

          this.enriquecerRolesGestor();

          this.openModalTipoUsuario = true;
          this.abrirModalTipoUsuario();
        }
      },
    });
  }

  async consultarFuncionalidades() {
    let token;
    if (!this.isSecure) {
      token = this.loginResponse?.access_token;
    }
    return this.funcionalidadService
      .cargarFuncionalidadesPorTipoUsuario(this.tipoUsuarioSeleccionado, token)
      .subscribe({
        next: response => {
          sessionStorage.setItem(
            Constants.FUNCIONALIDADES,
            JSON.stringify(response)
          );
          this.tipoUsuarioSeleccionado === Constants.ID_TIPO_USUARIO_CIUDADANO ||
            this.tipoUsuarioSeleccionado === Constants.ID_TIPO_USUARIO_ABOGADO
            ? this.router.navigateByUrl('procesos/resumen')
            : this.router.navigateByUrl(response[0]?.url || '/');
        },
      });
  }

  obtenerTipoUsuario(tipoUsuarioSeleccionado: number) {
    this.tipoUsuarioSeleccionado = tipoUsuarioSeleccionado;

    let selected = this.tiposUsuario.find(
      tipo => tipo.Id == tipoUsuarioSeleccionado
    ) as any;

    console.log('✓ Rol seleccionado completo:', selected);

    sessionStorage.setItem(Constants.USER_TYPE, JSON.stringify(selected));
    this.utilService.setRole(selected?.Nombre || null);

    // Actualizar loginResponse
    if (this.loginResponse?.usuario && selected) {
      this.loginResponse.usuario.tipoUsuario = {
        Id: selected.Id,
        Tipo_Usuario: selected.Nombre,
        Id_Entidad: selected.Id_Entidad,
        Rol_Externo: selected.Rol_Externo,
        Estado: true
      };

      console.log('✓ Rol_Externo en loginResponse:', this.loginResponse.usuario.tipoUsuario.Rol_Externo);
    }

    this.consultarFuncionalidades();
    this.loginCorrecto(this.loginResponse!);
    this.ModalTipoUsuarioComponent.abrirCerrarModal();
  }

  private startUserProcess(
    numeroIdentificacion: string,
    tipoIdentificacion: string,
    idTipoDocumento: number,
    idUsuario: number,
    idTipoUsuario: number
  ): void {
    if (!numeroIdentificacion || !tipoIdentificacion) {
      this.notificationService.addNotification(
        'error',
        'Número de identificación o tipo de identificación no definidos'
      );
      return;
    }

    const userInfo = this.loginResponse?.usuario;
    const rolExterno = userInfo?.tipoUsuario?.Rol_Externo;

    console.log('startUserProcess - Rol detectado:', rolExterno);

    if (rolExterno === Constants.ROL_EXTERNO_GESTOR_EMPRESA) {
      const userTypeString = sessionStorage.getItem(Constants.USER_TYPE);

      if (userTypeString) {
        const selectedRole = JSON.parse(userTypeString);
        if (selectedRole.empresaInfo) {
          console.log(`Sincronizando para empresa: ${selectedRole.empresaInfo.razonSocial} (${selectedRole.empresaInfo.nit})`);

          this.processService
            .sincronizarExpedientes(
              selectedRole.empresaInfo.nit,
              selectedRole.empresaInfo.tipoDocumento,
              selectedRole.empresaInfo.idTipoDocumento,
              idUsuario,
              idTipoUsuario
            )
            .subscribe({
              next: () => {
                this.notificationService.addNotification(
                  'success',
                  `Sincronización iniciada para ${selectedRole.empresaInfo.razonSocial}`
                );
              },
              error: () => {
                this.notificationService.addNotification(
                  'error',
                  `Error al sincronizar expedientes de ${selectedRole.empresaInfo.razonSocial}`
                );
              },
            });
        } else {
          console.warn('El rol de gestor no tiene información de empresa asociada');
        }
      }
    } else {
      // Flujo original para Ciudadano/Abogado
      this.processService
        .sincronizarExpedientes(
          numeroIdentificacion,
          tipoIdentificacion,
          idTipoDocumento,
          idUsuario,
          idTipoUsuario
        )
        .subscribe({
          next: () => {
            this.notificationService.addNotification(
              'success',
              'Sincronización de expedientes iniciada exitosamente'
            );
          },
          error: () => {
            this.notificationService.addNotification(
              'error',
              'Error al sincronizar expedientes'
            );
          },
        });
    }

    // Listener de cambios (sin cambios)
    const cambiosExpedientes: { radicado: string; action: string }[] = [];
    let timeout: any = null;

    this.socketService.listenToExpedienteChanges((data: any) => {
      cambiosExpedientes.push(data);

      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(() => {
        if (cambiosExpedientes.length > 0) {
          const creados = cambiosExpedientes
            .filter(item => item.action === 'created')
            .map(item => item.radicado)
            .join(', ');

          const actualizados = cambiosExpedientes
            .filter(item => item.action === 'updated')
            .map(item => item.radicado)
            .join(', ');

          if (creados) {
            this.notificationService.addNotification(
              'info',
              `Los siguientes expedientes han sido creados: ${creados}`
            );
          }
          if (actualizados) {
            this.notificationService.addNotification(
              'info',
              `Los siguientes expedientes han sido actualizados: ${actualizados}`
            );
          }

          cambiosExpedientes.length = 0;
          timeout = null;
        }
      }, 3000);
    });
  }

  onSubmitCiudadanosDigitales(action: string) {
    window.location.href = this.URL_LOGIN;
  }

  goCrearCuenta() {
    this.router.navigateByUrl('/autenticacion-digital', {
      state: { origen: 'crear-cuenta' },
    });
  }

  goLogin() {
    window.open(`${this.URL_LOGIN}`, '_blank', 'noopener,noreferrer');
  }

  goLoginEmpresa() {
    this.router.navigateByUrl('/loginAdmin', {
      state: { loginEmpresa: true },
    });
  }

  goRememberPassword() {
    this.router.navigateByUrl('/autenticacion-digital', {
      state: { origen: 'recuperar-password' },
    });
  }

  private enriquecerRolesGestor(): void {
    const rolesGestor = this.tiposUsuario.filter(
      (rol: any) => rol.Rol_Externo === Constants.ROL_EXTERNO_GESTOR_EMPRESA
    );

    if (rolesGestor.length > 0 && this.loginResponse?.usuario?.idPersona) {
      this.usuariosGestoresService
        .obtenerEmpresasPorGestor(this.loginResponse.usuario.idPersona)
        .subscribe({
          next: (response: ObtenerEmpresasGestorDTO) => {
            if (response.data.tieneEmpresas && response.data.empresas.length > 0) {
              // Asociar cada rol de gestor con su empresa correspondiente
              rolesGestor.forEach((rol: any) => {
                const empresa = response.data.empresas.find(
                  (emp: EmpresaGestorDTO) => rol.Nombre.includes(emp.razonSocial)
                );

                if (empresa) {
                  // Agregar información de la empresa al rol
                  rol.empresaInfo = {
                    nit: empresa.nit,
                    razonSocial: empresa.razonSocial,
                    tipoDocumento: empresa.tipoDocumento,
                    idTipoDocumento: empresa.idTipoDocumento,
                  };
                }
              });

              console.log('Roles enriquecidos con info de empresa:', this.tiposUsuario);
            }
          },
          error: err => {
            console.error('Error al enriquecer roles con empresas:', err);
          },
        });
    }
  }
}
